import * as Yup from 'yup';

export const AnnouncementSchema = Yup.object().shape({
  noticeType: Yup.string().required('Announcement type is required'),
  title: Yup.string()
    .required('Title is required')
    .min(4, 'Minimum 4 characters')
    .max(50, 'Maximum 50 characters'),
  text: Yup.string()
    .required('Content is required')
    .min(4, 'Minimum 4 characters')
    .max(250, 'Maximum 250 characters'),
  category: Yup.string().when('noticeType', {
    is: 'GENERAL',
    then: Yup.string().required('Category is required')
  }),
  toggleActionButton: Yup.boolean(),
  callToActionLabel: Yup.string()
    .nullable()
    .min(4, 'Minimum 4 characters')
    .max(30, 'Maximum 30 characters')
    .when('toggleActionButton', {
      is: true,
      then: Yup.string().required('Action button label is required')
    }),
  callToActionLink: Yup.string()
    .nullable()
    .url('Enter correct url format')
    .max(250, 'Maximum 250 characters')
    .when('toggleActionButton', {
      is: true,
      then: Yup.string().required('Action button label is required')
    }),
  startAtDateTime: Yup.string()
    .test(
      'check-valid-start-date-end-date-1',
      'The start date cannot be after the end date',
      function (value: any) {
        if (value) {
          const startAtVal = value;
          const endAtVal = this.parent.endAtDateTime;
          if (endAtVal < startAtVal) {
            return false;
          } else {
            return true;
          }
        }
        return true;
      }
    )
    .test(
      'check-valid-start-at-time',
      'Invalid format for start time (hh:mm)',
      function () {
        const startAtTimeVal = this.parent.startAtTime;
        if (startAtTimeVal) {
          const regex = new RegExp('^(0?[1-9]|1[0-2]):[0-5][0-9]$');
          if (regex.test(startAtTimeVal) === false) {
            return false;
          } else {
            return true;
          }
        }
        return true;
      }
    ),
  endAtDateTime: Yup.string()
    .test(
      'check-valid-start-date-end-date-2',
      'The end date cannot be before start date',
      function (value: any) {
        if (value) {
          const endAtVal = value;
          const startAtVal = this.parent.startAtDateTime;
          if (endAtVal < startAtVal) {
            return false;
          } else {
            return true;
          }
        }
        return true;
      }
    )
    .test(
      'check-valid-end-at-time',
      'Invalid format for end time (hh:mm)',
      function () {
        const endAtTimeVal = this.parent.endAtTime;
        if (endAtTimeVal) {
          const regex = new RegExp('^(0?[1-9]|1[0-2]):[0-5][0-9]$');
          if (regex.test(endAtTimeVal) === false) {
            return false;
          } else {
            return true;
          }
        }
        return true;
      }
    ),
  startAt: Yup.string().required('Start date is required'),
  endAt: Yup.string().required('End date is required'),
  icon: Yup.string().when('noticeType', {
    is: 'GENERAL',
    then: Yup.string().required('Icon is required')
  }),
  targetRoles: Yup.string().when('noticeType', {
    is: 'GENERAL',
    then: Yup.string()
      .required('Roles is required')
      .test(
        'validate-cross-existance',
        "Unauthenticated can't be used with other roles",
        function (value) {
          if (value) {
            const rolesArray = value.split(',');
            if (rolesArray.length > 1) {
              const found = rolesArray.find(
                (ele: any) => ele === 'UNAUTHENTICATED'
              );
              if (found !== undefined) {
                return false;
              } else {
                return true;
              }
            }
          }
          return true;
        }
      )
  }),
  targetOrganisations: Yup.string()
    .nullable()
    .when('noticeType', {
      is: 'MEMBER',
      then: Yup.string().required('Organisation is required')
    })
});
